import { useForm } from "@/form";
import { defineStore } from "pinia";

export const useStore = defineStore("textBlocks", {
    state: () => {
        return {
            textBlocksData: [],
            isLoadedData: false,
        };
    },

    getters: {
        localTextBlocks: (state) => {
            return state.textBlocksData?.local ?? [];
        },
        otomaticAITextBlocks: (state) => {
            return state.textBlocksData?.otomatic_ai ?? [];
        },
        textBlocks: (state) => {
            return state.textBlocksData;
        },
    },

    actions: {
        async fetch() {
            try {
                this.isLoadedData = false;
                this.textBlocksData = await useForm().post("text_blocks_index");
                this.isLoadedData = true;
            } catch (error) {
                return error;
            }
        },
    },
});
